"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CityKnowledge = void 0;
var CityKnowledge;
(function (CityKnowledge) {
    CityKnowledge["LESS_THAN_ONE_YEAR"] = "LESS_THAN_ONE_YEAR";
    CityKnowledge["BETWEEN_ONE_FIVE_YEARS"] = "BETWEEN_ONE_FIVE_YEARS";
    CityKnowledge["BETWEEN_FIVE_TEN_YEARS"] = "BETWEEN_FIVE_TEN_YEARS";
    CityKnowledge["MORE_THAN_TEN_YEARS"] = "MORE_THAN_TEN_YEARS";
})(CityKnowledge = exports.CityKnowledge || (exports.CityKnowledge = {}));
//# sourceMappingURL=CityKnowledge.js.map